import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import CommonDemoModalStore from './store';
import Button, { buttonType } from '@src/components/button';
const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const CommonDemoModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }
  const mecheInfo = store.mechaStore?.mechaInfo;

  const renderTextModal = () => {
    return (
      <div className={cx(styles.commonDemoModalRoot, styles.textModal)}>
        <div className={styles.commonDemoModalBox}>
          <div className={styles.title}>{mecheInfo?.basic_title}</div>
          <div className={styles.name}>{mecheInfo?.mecha_name}</div>
          <div className={styles.info}>
            {mecheInfo?.basic_number} <br />
            {mecheInfo?.basic_manufacturer} <br />
            {mecheInfo?.basic_height} <br />
            {mecheInfo?.basic_tareWeight} <br />
            {mecheInfo?.basic_grossWeight}
          </div>
          <div className={styles.title}>{mecheInfo?.background_title}</div>
          <div
            className={cx(styles.info, styles.backGround)}
            dangerouslySetInnerHTML={{ __html: mecheInfo?.background_content?.replace(/(\r\n|\\n)/g, '<br />') }}
          />
        </div>

        <Button
          className={cx(styles.closeBtn)}
          buttonType={buttonType.ROTATE}
          onClick={() => {
            store.onClickClose();
            store.onClose();
          }}
        />
      </div>
    );
  };

  const renderImageModal = () => {
    return (
      <div className={cx(styles.commonDemoModalRoot, styles.imageModal)}>
        <img className={styles.commonBgModalBox} src={mecheInfo?.background_image} alt="机兵背景" />
        <Button
          className={cx(styles.closeBtn)}
          buttonType={buttonType.ROTATE}
          onClick={() => {
            store.onClickClose();
            store.onClose();
          }}
        />
      </div>
    );
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      {mecheInfo?.type_option === '2' ? renderImageModal() : null}
      {mecheInfo?.type_option === '1' ? renderTextModal() : null}
    </ModalContainer>
  );
};

export default wrapStore(CommonDemoModal, CommonDemoModalStore);
